import React from 'react'; // eslint-disable-line
import { ClaimEventDetailsView } from '../common/claim-details/views/claim-event-details';
import { ContactPersonView } from '../common/contact-person';
import { DisabilityDetailsView } from '../common/disability-details';
import { ForensicInputView } from '../common/forensic-input';
import { InformationRecordView } from '../common/information-record';
import { LifeAssuredView } from '../common/life-assured';
import { MedicalOfficerInputView } from '../common/medical-officer-input';
import { PolicySummaryView } from '../common/policy-summary';
import { ReinsuranceInputView } from '../common/reinsurance-input';
import { RetrospectiveUnderwritingDecisionView } from '../common/retrospective-underwriting-decision';
import { Synopsis } from '../common/synopsis/synopsis';
import { UnderwritingView } from '../common/underwriting';
import FormDetailsView from '../living-lifestyle/form-details/form-details';
import { RulesResultsView } from '../common/rules/views/results-view';

export const TerminalIllnessSynopsis = () => {
    return (
        <Synopsis>
            <ContactPersonView />
            <LifeAssuredView />
            <ClaimEventDetailsView
                causeOfClaimLabel="Current Claim Diagnosis"
                showTreatingSpecialist={true}
            />
            <DisabilityDetailsView />
            <PolicySummaryView />
            <InformationRecordView />
            <MedicalOfficerInputView />
            <UnderwritingView />
            <FormDetailsView />
            <RetrospectiveUnderwritingDecisionView />
            <ForensicInputView />
            <ReinsuranceInputView />
            <RulesResultsView />
        </Synopsis>
    );
};
